import React, { useEffect, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { setPageSEO } from '../utils/seo.js';
import './BrandLinkPage.css';

function getBrandValue(brandname) {
  if (!brandname) {
    return '';
  }

  try {
    return decodeURIComponent(brandname).trim();
  } catch {
    return brandname.trim();
  }
}

function BrandLinkPage() {
  const { brandname } = useParams();
  const widgetContainerRef = useRef(null);
  const brandId = useMemo(() => getBrandValue(brandname), [brandname]);

  useEffect(() => setPageSEO({
    title: 'Customer Testimonials | Clientalio Wall of Love',
    description: 'View authentic customer testimonials collected and published with Clientalio.',
    canonical: `https://clientalio.com/w/${encodeURIComponent(brandId)}`,
    ogTitle: 'Customer Testimonials | Clientalio Wall of Love',
    ogDescription: 'View authentic customer testimonials collected and published with Clientalio.',
    twitterTitle: 'Customer Testimonials | Clientalio Wall of Love',
    twitterDescription: 'View authentic customer testimonials collected and published with Clientalio.'
  }), [brandId]);

  useEffect(() => {
    const widgetContainer = widgetContainerRef.current;

    if (!widgetContainer || !brandId) {
      return undefined;
    }

    widgetContainer.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://apiclientalio.azurewebsites.net/widgets/wall-of-love-embed.js';
    script.setAttribute('data-id', brandId);
    script.async = true;
    widgetContainer.appendChild(script);

    return () => {
      widgetContainer.innerHTML = '';
    };
  }, [brandId]);

  return (
    <main className="brand-link-page">
      <div className="brand-link-widget-preview" ref={widgetContainerRef}>
        <p>Loading testimonials...</p>
      </div>
    </main>
  );
}

export default BrandLinkPage;
